import { render, staticRenderFns } from "./CitasFormDialog.vue?vue&type=template&id=5326f85e"
import script from "./CitasFormDialog.vue?vue&type=script&lang=js"
export * from "./CitasFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports